import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { expenses_response, expensesType_response } from "../../services/api/api";

// Models


export interface iState extends expenses_response {
  enabled?: boolean,
  expense_type?: expensesType_response,
  expense_mode_id?: number,
  invoice_copy_file?: File,
  invoice_copy_spare?: string,
  new_line?: boolean,
}
interface iPaymentVouchers {[key:number]:iState[]}

// Payment vouchers state
export interface paymentVouchersState {
    isLoaded: boolean, // First load
    isLoading: boolean, // On filtering laoder
    isFetching: boolean,
    hasMore: boolean,

    page:number,
    expensesType:expensesType_response [],
    expensesList :iState[]
}

const initialPaymentVouchersState: paymentVouchersState = {
    isLoaded: false,
    isLoading: false,
    isFetching: false,
    hasMore: true,

    page:1,
    expensesType:[],
    expensesList:[]
}

// payment vouchers slice
export const paymentVouchersSlice = createSlice({
    name: 'payment_vouchers',
    initialState: initialPaymentVouchersState,
    reducers: {
        init: (state,{payload}:PayloadAction<iState[]>)=>{
            state.expensesList=payload
        }
        ,
        initExpensesType: (state,{payload}:PayloadAction<expensesType_response[]>)=>{
            state.expensesType=payload
        }
        ,
        setIsLoaded: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoaded = payload
        },
        setIsLoading: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoading = payload
        },
        setIsFetching: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isFetching = payload
        },
        setHasMore: ( state, {payload}: PayloadAction<boolean> ) => {
            state.hasMore = payload
        },
        addPaymentVouchers: ( state, {payload}: PayloadAction<expenses_response[]> ) => {
            state.expensesList =state.expensesList?
            [...state.expensesList,...payload] 
            : [ ...payload ]
        },
        updatePaymentVoucher: ( state, {payload}: PayloadAction<expenses_response> ) => {
            let index = state.expensesList
            .findIndex( paymentVoucher => paymentVoucher.id === payload.id )
            if( index !== -1 )
                state.expensesList[index] = payload
        },
        deletePaymentVouchers: ( state, {payload}: PayloadAction<number[]> ) => {
            payload.map(id => {
                let index = state.expensesList
                .findIndex( paymentVoucher => paymentVoucher.id === id )
                if( index != -1 )
                    state.expensesList.splice( index, 1 )
            })
        },
        reset: ( state ) => {
            state.expensesList = []
            state.hasMore = true
        },
        setPage:(state,{payload}:PayloadAction<number>)=>{
            state.page=payload
        }
    }
})